import { RSAA } from 'redux-api-middleware';

// Constants
export const AUTH_IS_PARSING_HASH = 'AUTH_IS_PARSING_HASH';
export const AUTH_IS_FETCHING = 'AUTH_IS_FETCHING';
export const AUTH_LOGIN_SUCCESS = 'AUTH_LOGIN_SUCCESS';
export const AUTH_LOGIN_FAILED = 'AUTH_LOGIN_FAILED';
export const AUTH_SET_TOKEN = 'AUTH_SET_TOKEN';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';

// Actions
export const authenticate = (username, password) => {
  return {
    [RSAA]: {
      controlKey: 'CTRL_LOGIN',
      controlAction: 'bci:add',
      body: {
        Username: username,
        Password: password,
        RedirectUrl: ''
      },
      types: [AUTH_IS_FETCHING, AUTH_LOGIN_SUCCESS, AUTH_LOGIN_FAILED]
    }
  };
};

export const logout = () => {
  return {
    type: AUTH_LOGOUT
  };
};

export const isParsingHash = () => {
  return {
    type: AUTH_IS_PARSING_HASH
  };
};

export const doLogin = (accessToken, idToken) => {
  return {
    type: AUTH_LOGIN_SUCCESS,
    accessToken,
    idToken
  };
};

export const setToken = (accessToken, idToken) => {
  return {
    type: AUTH_SET_TOKEN,
    accessToken,
    idToken
  };
};

// Initial State
export const initialState = {
  isFetching: false,
  accessToken: null,
  idToken: null,
  error: null
};

// Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case AUTH_IS_FETCHING:
    case AUTH_IS_PARSING_HASH:
      return { ...state, isFetching: true, error: null };

    case AUTH_LOGIN_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        accessToken: action.accessToken,
        idToken: action.idToken
      };

    case AUTH_LOGIN_FAILED:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };

    case AUTH_SET_TOKEN:
      return {
        ...state,
        accessToken: action.accessToken,
        idToken: action.idToken
      };

    case AUTH_LOGOUT:
      return {
        ...state,
        isFetching: false,
        accessToken: null,
        idToken: null,
        error: null
      };

    default:
      return state;
  }
};
